import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Grid from "@mui/material/Grid";
import Section from "../components/ui/Section";
import { FAQS } from "../content/faqs";
import { headers } from "../content/meta";

export default function FAQ() {
  return (
    <Section id="faq" header={headers.faq}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <Stack spacing={1.25}>
            {FAQS.map((item, idx) => (
              <Accordion
                key={idx}
                disableGutters
                square
                sx={{ borderRadius: 2, overflow: "hidden" }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ "& .MuiAccordionSummary-content": { my: 1 } }}
                >
                  <Typography sx={{ fontWeight: 800 }}>{item.q}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ pt: 0 }}>
                  <Typography color="text.secondary" sx={{ lineHeight: 1.9 }}>
                    {item.a}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>
        </Grid>
      </Grid>
    </Section>
  );
}
